// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1VotN","title":"BackImages_title__3i3rR","images":"BackImages_images__3SgJV"};